export const getBoardFeaturesUrl = (boardId: number) =>
	`/rest/agile/latest/board/${boardId}/features`;
